import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
  ListGroupItem,
  OverlayTrigger,
  ProgressBar,
  Tooltip,
} from "react-bootstrap";
import { connect } from "react-redux";
import { File } from "../../../docuclipper/DocuclipperTypes";
import { RemoveFileFn } from "../../../redux/reducers/FilesServer";
type Props = {
  file: File;
  removeFile: RemoveFileFn;
};
type ReduxProps = {};
export const UploadDetails: React.SFC<Props & ReduxProps> = ({
  file,
  removeFile,
}) => {
  const removeFileFn = () => removeFile({ file });
  const fileSpan = (
    <span
      style={{
        color: file.needsPassword
          ? "red"
          : file.status === "ok"
          ? "green"
          : "red",
        textDecoration: file.status === "ok" ? "" : "line-through",
        verticalAlign: "middle",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "85%",
        width: "85%",
        display: "inline-block",
        paddingLeft: "10px",
      }}
      className="ml-2"
    >
      {file.file ? file.file.path : ""}
      {file.needsPassword && (
        <small>
          <span className="ml-1" style={{ color: "red" }}>
            (Invalid password)
          </span>
        </small>
      )}
    </span>
  );

  return (
    <ListGroupItem
      className="justify-content-between p-1"
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {file.uploading ? (
        <ProgressBar
          style={{ maxWidth: "85%", width: "85%" }}
          now={file.progress}
          label={file.file ? file.file.path : ""}
        ></ProgressBar>
      ) : (
        fileSpan
      )}

      {!file.uploading && (
        <OverlayTrigger
          popperConfig={{
            modifiers: {
              preventOverflow: {
                enabled: false,
              },
            } as any,
          }}
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id="removeFile">Remove file</Tooltip>}
        >
          <span
            className="float-right ml-1 mr-2 d-block span-delete-file"
            onClick={removeFileFn}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon size="1x" icon="trash" />
          </span>
        </OverlayTrigger>
      )}
    </ListGroupItem>
  );
};
const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps, {})(UploadDetails);
